import { validate as isUUID } from 'uuid';
import snakeCaseToCamelCase from '~/libs/api-hooks/architect/utils/snakeCaseToCamelCase';

export interface ApiObject {
  [key: string]: any;
}

const mapApiObjectToCamelCase = <Result>(
  apiObject: ApiObject | ApiObject[],
): Result => {
  if (apiObject === null || typeof apiObject !== 'object') {
    // @ts-ignore
    return apiObject;
  }

  const mappedObject = {};

  Object.keys(apiObject).forEach((key) => {
    const newKey = isUUID(key) ? key : snakeCaseToCamelCase(key);

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (Array.isArray(apiObject[key])) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      mappedObject[newKey] = apiObject[key].map(mapApiObjectToCamelCase);
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      mappedObject[newKey] = mapApiObjectToCamelCase(apiObject[key]);
    }
  });

  return mappedObject as Result;
};

export default mapApiObjectToCamelCase;
